<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()"><span>Taurino</span></a>
  </div>
</div>
<div class="header-container" *ngIf="amIRoot()">
  <button class="btn btn-primary mr-2" (click)="masajearRoles()">Masajear roles</button> sólo ves esto porque sos root@root bro'
</div>
<div class="header-container">
  <div ngbDropdown class="d-inline-block" #myDrop="ngbDropdown">
    <button mat-icon-button ngbDropdownToggle id="dropDownNotificaciones">
      <mat-icon class="icon">notifications_outline</mat-icon>
      <span class="badge badge-danger" *ngIf="noLeidas > 0">{{noLeidas}}</span>
    </button>
    <div ngbDropdownMenu aria-labelledby="dropDownNotificaciones" class="ngb-menu">
      <div ngbDropdownItem class="mb-2 btn-noti">
        <div class="row">
          <div class="col text-right">
            <button class="btn btn-link" (click)="openTodas()">Ver todas</button>
          </div>
        </div>
      </div>
      <div ngbDropdownItem *ngFor="let noti of notificaciones" class="mb-2 btn-noti">
        <div class="row">
          <div class="col-8">
            <span class="box">{{noti.alerta.titulo}}: {{noti.alerta.mensaje}}</span><span class="badge badge-danger" [hidden]="noti.leido">No
              leída</span>
          </div>
          <div class="col-4 text-right">
            <button (click)="openNotificacion(noti);$event.stopPropagation(); myDrop.open();" data-toggle="tooltip"
              data-placement="top" title="Ir" class="btn btn-primary btn-sm" [hidden]="!noti.alerta?.link">
              <mat-icon class="icon">launch_outline</mat-icon>
            </button>
            <button (click)="marcarComoLeida(noti);$event.stopPropagation(); myDrop.open();" data-toggle="tooltip"
              data-placement="top" title="Marcar como leída" class="btn btn-secondary btn-sm ml-1"
              [hidden]="noti.leido">
              <mat-icon class="icon">mark_chat_read_outline</mat-icon>
            </button>
            <button (click)="posponer(noti);$event.stopPropagation(); myDrop.open();" [hidden]="noti.leido"
              class="btn btn-warning btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Posponer">
              <mat-icon class="icon">more_time_outline</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user [nbContextMenu]="userMenu" nbContextMenuTrigger="click" [onlyPicture]="userPictureOnly"
        [name]="user?.usuario" [picture]="user?.img">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>